import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"

/**
 * OKS-66 — Full-page empty state.
 *
 * Renders only when `state === "empty"` (zero brands AND zero agencies
 * AND zero creators platform-wide — TRD K9). No CTA per UX Spec §3
 * OQ-3: admin doesn't directly create tenants (the OKS-12 invite flow
 * owns that surface).
 *
 * The "zero signups in window" case is NOT this state — it's the
 * `<AnalyticsGrowthChart>` per-card empty variant.
 */
export function AnalyticsEmptyState() {
  const { t } = useTranslation()

  return (
    <Card data-testid="admin-analytics-empty">
      <CardContent className="text-muted-foreground flex flex-col items-center justify-center gap-3 py-16 text-center text-sm">
        <p className="text-foreground text-lg font-semibold">
          {t("admin.analytics.empty.heading")}
        </p>
        <p className="max-w-md">{t("admin.analytics.empty.body")}</p>
      </CardContent>
    </Card>
  )
}
